import React, { memo, ReactNode, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { areEqual } from 'Utils/equalityChecks';
import { width } from 'Utils/screen';

import { DashboardLayout } from 'Components/Layouts';
import { SupportProvider } from 'Context/Support';
import { SupportPanel } from 'Components/Support/SupportPanel/SupportPanel';
import { MobileWarningModal } from 'Containers/MobileWarningModal';

interface Props {
  children: ReactNode;
}

function DashboardWrapperContainer({ children }: Props) {
  const location = useLocation();
  const { pathname } = location;

  // this is to slide the sidebar on desktop view
  const [sideBarDesktop, setSideBarDesktop] = useState(false);

  // this is to slide the sidebar on mobile view
  const [sideBarMobile, setSideBarMobile] = useState(false);

  const toggleSideBar = useCallback(() => {
    if (width <= 991) {
      setSideBarMobile((prev) => !prev);
    } else {
      setSideBarDesktop((prev) => !prev);
    }
  }, []);

  // reset the sidebar menu on route change
  useEffect(() => {
    setSideBarMobile(false);
  }, [pathname]);

  return (
    <SupportProvider>
      <DashboardLayout
        toggleSideBar={toggleSideBar}
        sideBarMobile={sideBarMobile}
        sideBarDesktop={sideBarDesktop}
        pathname={pathname}
      >
        {children}
        <MobileWarningModal />
      </DashboardLayout>
      <SupportPanel />
    </SupportProvider>
  );
}

const DashboardWrapperContainerMemo = memo(DashboardWrapperContainer, areEqual);

export { DashboardWrapperContainerMemo as DashboardWrapperContainer };
